import { render } from "./FAQsPage.vue?vue&type=template&id=28eaeeb8&ts=true"
import script from "./FAQsPage.vue?vue&type=script&lang=ts"
export * from "./FAQsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__